import { CALL_API } from '../../common/middleware/api';

export const USER_SETTINGS_FETCH_REQUEST = 'USER_SETTING_GET_REQUEST';
export const USER_SETTINGS_FETCH_SUCCESS = 'USER_SETTING_GET_SUCCESS';
export const USER_SETTINGS_FETCH_FAILURE = 'USER_SETTING_GET_FAILURE';

export const USER_SETTINGS_UPDATE_REQUEST = 'USER_SETTINGS_UPDATE_REQUEST';
export const USER_SETTINGS_UPDATE_SUCCESS = 'USER_SETTINGS_UPDATE_SUCCESS';
export const USER_SETTINGS_UPDATE_FAILURE = 'USER_SETTINGS_UPDATE_FAILURE';

export const fetchUserSettings = (onErrorEvent, onSuccessEvent) => ({
	[CALL_API]: {
		types: [USER_SETTINGS_FETCH_REQUEST, USER_SETTINGS_FETCH_SUCCESS, USER_SETTINGS_FETCH_FAILURE],
		endpoint: `api/account/settings`,
		onSuccessEvent,
		onErrorEvent
	}
});

export const updateUserSettings = (settings) => ({
	[CALL_API]: {
		types: [USER_SETTINGS_UPDATE_REQUEST, USER_SETTINGS_UPDATE_SUCCESS, USER_SETTINGS_UPDATE_FAILURE],
		endpoint: `api/account/settings`,
		method: 'PUT',
		request: settings,
		form: 'userSettings'
	}
});